import { JSONRPCClient } from 'json-rpc-2.0';
import { generatePromiseObjects } from '../helpers';
import { asperaSdk } from '../../index';
export var getRpcServerUrl = function () {
    return "".concat(asperaSdk.globals.asperaAppUrl, ":").concat(asperaSdk.globals.rpcPort);
};
/**
 * Wraps a promise like object and returns a promise that supports catch.
 *
 * @param promise the HTTP promise like to wrap
 *
 * @returns promise for the HTTP connection with catch supporting error
 */
export var handlePromiseLikeErrors = function (promise) {
    var promiseInfo = generatePromiseObjects();
    promise.then(function (response) {
        promiseInfo.resolver(response);
    }, function (error) {
        promiseInfo.rejecter(error);
    });
    return promiseInfo.promise;
};
/**
 * JSON RPC client using HTTP (fetch) as transport.
 */
var JSONRPCHttpClient = /** @class */ (function () {
    function JSONRPCHttpClient() {
        var _this = this;
        /**
         * Request handler for the JSON-RPC client. This function is called by the JSON-RPC library
         * after forming the RPC request.
         *
         * @param request JSON-RPC request to send to the server
         */
        this.handleRequest = function (request) {
            var options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(request),
            };
            var rpcServerURL = getRpcServerUrl();
            return fetch(rpcServerURL, options).then(function (response) {
                if (response.ok) {
                    return response.json().then(function (rpcResponse) { return _this.client.receive(rpcResponse); });
                }
                else if (request.id !== undefined) {
                    throw Promise.reject(response.statusText);
                }
            });
        };
        this.request = function (method, data) {
            return _this.client.request(method, data);
        };
        this.client = new JSONRPCClient(this.handleRequest);
    }
    return JSONRPCHttpClient;
}());
/**
 * Client used for making requests to Aspera.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        var _this = this;
        this.request = function (method, payload) {
            if (payload === void 0) { payload = {}; }
            return handlePromiseLikeErrors(_this.httpClient.request(method, payload));
        };
        this.httpClient = new JSONRPCHttpClient();
    }
    ;
    return HttpClient;
}());
export var httpClient = new HttpClient();
export default {
    httpClient: httpClient,
    handlePromiseLikeErrors: handlePromiseLikeErrors,
};
